import { defineStore } from 'pinia'
import axiosInstance from '@/services'
import { useLookupsStore } from '@/stores/lookups'
import client_lookups from '@/assets/json/clientLookups.json'

export const useIndAddressMgmtStore = defineStore('addressMgmt', {
  state: () => {
    return {
      abroadAddresses: {},
      deliveryAddressesIdentity: {},
      deliveryAddressesPassport: {},
      localAddresses: {},

      countries: [],
      emirates: [],
      emirateCities: {},
      cityZones: [],
      deliveryMethods: [],
      deliveryCompanies: [],
      postalBranches: [],
      deliveryLandmarks: []
    }
  },
  getters: {
    isLookupsComplete() {
      const lookups = [
        this.countries,
        this.emirates,
        Object.keys(this.emirateCities),
        this.cityZones
      ]

      return lookups.every((l) => l.length > 0)
    }
  },
  actions: {
    async fetchAddresses(payload, to) {
      if (!to)
        throw new Error(
          '[Address management store] (fetchAddresses) Destination needs to be provided.'
        )

      if (Object.keys(this).includes(to) === false)
        throw new Error(
          '[Address management store] (fetchAddresses) Destination does not exist in state. Check your spelling!'
        )

      const body = {
        ...payload
      }

      const response = await axiosInstance.post('/api/addressesBook/management/search', body)

      this[to] = response
    },
    async fetchLookups() {
      if (this.isLookupsComplete) return

      const lookupsStore = useLookupsStore()

      if (this.countries.length === 0)
        this.countries = await lookupsStore.fetchLookup('/api/lookup/countries')

      if (this.emirates.length === 0)
        this.emirates = await lookupsStore.fetchLookup('/api/lookup/emirates')

      if (Object.keys(this.emirateCities).length === 0) {
        const { emirates: emiratesMapping } = client_lookups
        const promises = Object.entries(emiratesMapping).map(async ([emKey, emId]) => {
          const cities = await lookupsStore.fetchLookup(`/api/lookup/emirate/${emId}/UDBCity`)
          return {
            id: emId,
            label: emKey,
            cities
          }
        })

        /**
         * Promise.all returns an array.
         * so we need to map it based on the emirate id (emId)
         */
        const cities = await Promise.all(promises)
        cities.forEach((c) => (this.emirateCities[c.id] = c))
      }

      if (this.cityZones.length === 0)
        this.cityZones = await lookupsStore.fetchLookup('/api/lookup/getAllCityZones')

      if (this.deliveryMethods.length === 0)
        this.deliveryMethods = await lookupsStore.fetchLookup('/api/lookup/DeliveryMethods')
    },
    async fetchDeliveryDetails(deliveryMethodId, deliveryCompanyId) {
      const params = { deliveryMethodId, deliveryCompanyId }
      const response = await axiosInstance.get('/api/lookup/getDeliveryDetails', { params })

      const { landMarks, postalBranches } = response

      this.postalBranches = postalBranches.map((p) => {
        return {
          ...p,
          label: p.text || p.localizedName,
          value: +p.id
        }
      })

      this.deliveryLandmarks = landMarks.map((l) => {
        return {
          ...l,
          label: l.text || l.localizedName,
          value: +l.id
        }
      })
    },
    async deleteAddress(category, address) {
      await axiosInstance.get(`/api/addressesBook/management/delete/${address.id}`)
    }
  },
  persist: {
    storage: sessionStorage,
    pick: [
      'countries',
      'emirates',
      'emirateCities',
      'cityZones',
      'deliveryMethods',
      'deliveryCompanies'
    ]
  }
})
